import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import EditIcon from '@mui/icons-material/Edit';
import Divider from '@mui/material/Divider';
import ArchiveIcon from '@mui/icons-material/Archive';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { AddBox, CallSplit, Delete, MoreVert, PictureAsPdf, SaveAs, Undo } from '@mui/icons-material';
import { ListItemIcon, ListSubheader } from '@mui/material';
import { CatalogInitNumberDialog } from '../../modals/CatalogInitNumberDialog';

const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color: 'rgb(55, 65, 81)',
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                ),
            },
        },
        ...theme.applyStyles('dark', {
            color: theme.palette.grey[300],
        }),
    },
}));

export default function MatchcowlistMenu({ show, handleAdd, handleSplit, undoSplit }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };



    return (
        <div>
            <Button
                id="matchdialog-button"
                aria-controls={open ? 'matchdialog-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                variant="contained"
                disableElevation
                size="small"
                color="secondary"
                onClick={handleClick}

            >
                azioni lista
                <MoreVert />
            </Button>
            <StyledMenu
                id="cow-menu"
                MenuListProps={{
                    'aria-labelledby': 'cow-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <ListSubheader>azioni su lista soggetti</ListSubheader>
                {handleAdd &&
                <MenuItem  onClick={() => {
                    handleAdd(); 
                    handleClose()
                    }}
                     disableRipple>
                    <ListItemIcon>
                        <AddBox />
                    </ListItemIcon>
                    Inserisci altri soggetti manualmente
                </MenuItem>
                }
                {handleSplit &&
                <MenuItem onClick={() => {handleSplit(); handleClose()}} disableRipple>
                    <ListItemIcon>
                        <CallSplit />
                    </ListItemIcon>
                    Dividi lista
                </MenuItem>
                }
                {undoSplit &&
                <MenuItem onClick={() => {undoSplit(); handleClose()}} disableRipple>
                    <ListItemIcon>
                        <Undo />
                    </ListItemIcon>
                    Ripristina lista originale
                </MenuItem>
                }
            </StyledMenu>
        </div>
    );
}